import { type QueryKey, type UseQueryOptions, type UseQueryResult, useQuery } from "@tanstack/react-query"
import type { AxiosError } from "axios"

import { hours, seconds } from "@/3514/utils/time.utils"
import { ServerStateKeys } from "@/constants"

import type { ISurveysDto as IDto, ISurveysModel as IModel } from "./types"
import { type TSurveysApiUtils as TUtils, surveysApiUtils as utils } from "./utils"

type TParams = Pick<UseQueryOptions, "enabled">
type TQuery = UseQueryResult<IModel, AxiosError>

const { fetchSurveysList: fetcher, adaptSurveysList: adapter }: TUtils = utils

function useHook(params: TParams = { enabled: true }): ReturnType<(params: TParams) => TQuery> {
    return useQuery<IDto, AxiosError, IModel, QueryKey>({
        queryKey: [ServerStateKeys.Surveys],
        queryFn: fetcher,
        select: adapter,
        notifyOnChangeProps: ["data", "isFetching"],
        staleTime: hours(1),
        gcTime: hours(1),
        refetchOnWindowFocus: "always",
        refetchOnMount: true,
        refetchOnReconnect: true,
        throwOnError: false,
        networkMode: "always",
        retry: 1,
        retryDelay: seconds(5),
        ...params
    })
}

export { useHook as useSurveysQuery, type TQuery as TSurveysQuery }
